import { track } from '../../analytics/events';

export const desktopAnalytics = () => ({
  click: {
    offersOptIn: (value) => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: value === 'YES' ? 'Yes' : 'No',
        name: 'Special Offers Opt In',
        location: 'Instant Savings',
      },
      actionOutcome: 'Submit',
    }),
    next: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'Next',
      },
      actionOutcome: 'INTERNALLINK',
    }),
    selectedOffers: (
      accountId,
      adGroupId,
      adId,
      templateId,
    ) => track('selectionCreated', {
      properties: {
        accountId,
        adGroupId,
        adId,
        templateId,
      },
    }),
  },
  view: {
    offerImpressed: (
      accountId,
      adGroupId,
      adId,
      id,
    ) => track('ImpressionCreated', {
      properties: {
        accountId,
        adGroupId,
        adId,
        templateId: id,
      },
    }),
  },
});

export const mobileAnalytics = () => ({
  click: {
    offersOptIn: (value) => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: value === 'YES' ? 'Yes' : 'No',
        name: 'Special Offers Opt In',
        location: 'Instant Savings',
      },
      actionOutcome: 'Submit',
    }),
    next: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'Next',
      },
      actionOutcome: 'INTERNALLINK',
    }),
    selectedOffers: (
      accountId,
      adGroupId,
      adId,
      templateId,
    ) => track('selectionCreated', {
      properties: {
        accountId,
        adGroupId,
        adId,
        templateId,
      },
    }),
  },
  view: {
    offerImpressed: (
      accountId,
      adGroupId,
      adId,
      id,
    ) => track('ImpressionCreated', {
      properties: {
        accountId,
        adGroupId,
        adId,
        templateId: id,
      },
    }),
  },
});
